import {Injectable} from '@angular/core';
import { Storage } from '@capacitor/storage';
import {ApiService} from 'app/core/services';
import {Login} from 'app/pages/authentication/interface';
import { PasswordReset } from "app/pages/authentication/interface";

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  private readonly FIRST_LOGIN_FLAG = 'quickSale_firstLogin';
  constructor(private apiService: ApiService) {
  }

  async login(params: Login): Promise<any> {
    const response = await this.apiService.post('/login', params).toPromise();
    if (response && response.first_login === true) {
      localStorage.setItem(this.FIRST_LOGIN_FLAG, 'true');
    } else {
     localStorage.removeItem(this.FIRST_LOGIN_FLAG)
    }
    return response;
  }

  // login(params: Login): Promise<any> {
  //   return this.apiService.post('/login', params).toPromise();
  // }


  resetPassword(params : PasswordReset) : Promise<any> {
    return this.apiService.post('/change-password', params).toPromise()
  }

  async getLanguage():Promise<any> {
    const lang = await Storage.get({key: 'lang'});
    return this.apiService.get(`/user/update-locale?locale=${lang.value.toUpperCase()}`).toPromise();
  }
}
